<template>
    <div>
        <h2>User Information</h2>
        <div v-if="userInfo">
            <p>Username: {{ userInfo.username }}</p>
            <!-- 根据你的用户信息结构添加其他字段 -->
            <p>Phone: {{ userInfo.phone }}</p>
            <p>regTime: {{ userInfo.register_time }}</p>
        </div>
        <p v-else>Loading...</p>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data () {
            return {
                userInfo: null
            };
        },
        created () {
            this.getUserInfo();
        },
        methods: {
            async getUserInfo () {
                try {
                    // 从 localStorage 或其他状态管理库获取 token  
                    const token = localStorage.getItem('token');
                    if (token) {
                        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    }
                    const response = await axios.get('/api/user');
                    this.userInfo = response.data;
                } catch (error) {
                    if (error.response) {
                        // 服务器返回了一个错误响应
                        console.error('Error message from server:', error.response.data.message);
                    } else if (error.request) {
                        // 请求已经发送，但没有收到响应
                        console.error('No response received:', error.request);
                    } else {
                        // 发送请求时出现了一些问题
                        console.error('Error:', error.message);
                    }
                }
            }
        }
    };
</script>